import React from 'react';
import times from 'lodash/times';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const LoadingModal = () => {
  return (
    <Modal isOpen>
      <ModalHeader>
        <Shimmer width={150} height={32} />
      </ModalHeader>

      <ModalBody>
        {times(3).map((key, index) => (
          <Shimmer key={key} height={64} mt={index !== 0 ? 16 : 0} />
        ))}
      </ModalBody>
    </Modal>
  );
};
